import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  gap: 12px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  gap: 12px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const MainUploadsContainter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  border: 1px solid ${(props) => props.theme.colors.black12};
  border-radius: 12px;
  padding: 12px;
`;

export const UploadsMainLayer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const UploadContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
`;

export const FileInput = styled.input`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  flex: 1;
`;

export const Button = styled.button<{ bgColor?: string; bgHover?: string }>`
  padding: 8px 16px;
  background-color: ${(props) =>
    props.bgColor ? props.theme.colors[props.bgColor] : "#357abd"};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: ${(props) =>
      props.bgHover ? props.theme.colors[props.bgHover] : "#2a5f93ff"};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
`;

export const SubTitle = styled.h3`
  font-size: 18px;
  color: #444;
  margin: 20px 0 10px;
`;

export const WarningText = styled.p`
  font-size: 12px;
  color: red;
`;
